<template>
  <b-modal v-model="isOpen" size="lg" centered
           header-class="modal-header-full"
           footer-class="d-none"
           hide-header-close>
    <template #title>
      <div class="header-layout">
        <div class="header-left">
          <h2 class="modal-title">
            <strong>{{ $t('Webportal.Dialog.FilterSettings') }}</strong>
          </h2>
          <p class="modal-description">
            {{ $t('Webportal.Dialog.FilterSettingsHint') }}
          </p>
        </div>
        <div class="header-actions">
          <b-button variant="outline-secondary" size="sm" @click="isOpen = false">
            {{ $t('Webportal.Dialog.Cancel') }}
          </b-button>
          <b-button variant="primary" size="sm" @click="handleAddOrEdit()" :disabled="!isFormValid">
            {{ isEditMode ? $t('Webportal.Apply') : $t('Webportal.Add') }}
          </b-button>
        </div>
      </div>
    </template>

    <template #default>
      <BOverlay :show="appLoading" variant="dark" opacity="0.5">
        <template #overlay>
          <default-spinner />
        </template>

        <div class="modal-content">
          <BFormFloatingLabel :label="$t('Webportal.KpiModal.NameHint')" class="mt-3">
            <BFormInput
              v-model="kpi.label"
              type="text"
              autocomplete="off"
              :state="kpi.label.trim() ? true : false"
            />
            <BFormInvalidFeedback :state="false" v-if="!kpi.label.trim()">
              {{ $t('Webportal.Dialog.FilterSettings.NameUsed') }}
            </BFormInvalidFeedback>
            <BFormValidFeedback :state="true" v-if="kpi.label.trim()">
              {{ $t('Webportal.Dialog.FilterSettings.NameAvailable') }}
            </BFormValidFeedback>
          </BFormFloatingLabel>

          <DetailFilterRow  ref="filterRef"
                            :disable-options="['Waves']"
                            :initial-selection="kpi.filter ? JSON.parse(kpi.filter) : {}" class="my-2" />
        </div>
      </BOverlay>
    </template>

  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { Plus } from 'lucide-vue-next';
import DetailFilterRow from '@/componentsv3/DetailFilterRow.vue';
import DefaultSpinner from '@/componentsv3/DefaultSpinner.vue';

export default {
  name: 'ModalDefineKpi',

  inject: ['delegateAddKpi'],
  emits: ['update:modelValue'],

  components: { Plus, DetailFilterRow, DefaultSpinner },

  props: {
    modelValue: { type: Boolean, default: false },
    kpi: { type: Object, required: true },
    isEditMode: { type: Boolean, default: false }
  },

  computed: {
    ...mapGetters('clientData', [ 'appLoading' ]),
    isOpen: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    },

    isFormValid() {
      return true;
    }
  },

  watch: {
    modelValue(newVal) {
      if (newVal) {
        this.resetForm();
      }
    }
  },

  methods: {
    resetForm() {

    },

    handleAddOrEdit() {
      const selection = this.$refs.filterRef.selection;
      this.delegateAddKpi({ kpi: this.kpi, index: 0, selection: JSON.parse(JSON.stringify(selection)), isEdit: this.isEditMode });
    },
  }
}
</script>

<style lang="scss" scoped>
.modal-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  border: unset;
}

.form-group {
  margin-bottom: 0;

  :deep(label) {
    font-size: 14px;
    font-weight: 500;
    color: #374151;
    margin-bottom: 8px;
  }
}

.form-select {
  :deep(.form-select) {
    font-size: 14px;
  }
}

</style>

